import { Divider } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AppContext } from "../../../context/AppContext";
import {
  createExamColumnDefs,
  toasterMessages,
} from "../../constants/QuestionBankConstants";
import {
  apiPaths,
  get,
  getData,
  postData,
} from "../../platform-components/api-integration-util";
import { Toaster } from "../../platform-components/Toaster";
import {
  getSelectedExamInfo,
  setSelectedExamInfo,
} from "../../platform-components/utils/configuration";
import { getUserDetails } from "../../platform-components/utils/shared-data.service";
import ExamForm from "../exam-form";
import AutomaticConfig from "./automatic-config";
import "./createexam.scss";
import ExamContent from "./exam-content";
import ExamModal from "./ExamModal";
import ManualConfiguration from "./manual-configuration";
import { getUniqueAfterMerge } from "./tablist";

export default function CreateExam(props) {
  const { courses, branches, tags, topics, users } = useContext(AppContext);
  let tenantId = getUserDetails()?.tenantId;
  let [gridOptions, setGridOptions] = useState({});
  let [showGrid, setShowGrid] = useState(false);
  let gridApi = useRef();
  let gridApi2 = useRef();
  const [tabValue, setTabValue] = React.useState(0);

  let { id, examid } = useParams();

  let [batches, setBatches] = useState([]);
  let [subjects, setSubjects] = useState([]);
  let [includeQuestionsFromQB, setIncludeQuestionsFromQB] = useState(true);
  let [manualQuestions, setManualQuestions] = useState([]);
  let [showWhereUsedGrid, setShowWhereUsedGrid] = useState(false);
  let [search, setSearch] = useState(false);
  let [showCourseInput, setShowCourseInput] = useState(false);
  let [automaticQuestion, setAutomaticQuestion] = useState({});
  let [batchValue, setBatchValue] = useState(
    examid ? getSelectedExamInfo().batchId : ""
  );
  let [branchValue, setBranchValue] = useState(
    examid ? getSelectedExamInfo().branchId : ""
    );
    
    console.log('branchValue: ', branchValue);
  let [subjectValue, setSubjectValue] = useState([]);

  let [filteredSubject, setFilteredSubject] = useState([]);
  let [tagValue, setTagValue] = useState([]);
  let [topicValue, setTopicValue] = useState([]);
  let [courseValue, setCourseValue] = useState([]);

  let [questionData, setQuestionData] = useState([]);
  let [examViewQuestionId, setExamViewQuestionId] = useState("");
  let [firstLoad, setFirstLoad] = useState(true);
  let [showViewQuestion, setShowViewQuestion] = useState(false);
  let [questionPopupData, setQuestionPopupData] = useState({});
  const [QBCount, setQBCount] = useState(0);
  const [nxtQuestion, setNxtQuestion] = useState(0);
  const [prevQuestion, setPrevQuestion] = useState(0);
  const [currentQuestn, setCurrentQuestion] = useState(null);
  const [approvedBy, setApprovedBy] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [automaticConfig, setAutomaticConfig] = useState([]);
  console.log("automaticConfig: ", automaticConfig);
  const [numOfTimesUsedInExam, setNumOfTimesUsedInExam] = useState(0);
  const [issueReported, setIssueReported] = useState({
    value: false,
    label: "False",
  });
  const [showFilter, setShowFilter] = useState(false);
  const [showFullscreen, setShowFullscreen] = useState(false);
  const [selectionHistory, setSelectionHistory] = useState([]);
  const [firstTimeApiCall, setFirstTimeApiCall] = useState(true);
  const [complexity, setComplexity] = useState("ALL");
  const [fullQuestions, setFullQuestions] = useState([]);

  const [createdDate, setCreatedDate] = useState(null);
  const [updatedDate, setUpdatedDate] = useState(null);

  const currentQuestion = (qId) => {
    setCurrentQuestion(qId);
    get(apiPaths.questionbyid, { id: qId })
      .then(({ result }) => {
        setShowWhereUsedGrid(false);
        setQuestionPopupData({ ...result });

        // nav(qId);
      })
      .catch((err) => console.log(err));
  };

  const { register, handleSubmit, watch, getValues, errors, setValue, reset } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
      validateCriteriaMode: "all",
    });

  useEffect(() => {
    if (examid) {
      setValue("array.0.examName", getSelectedExamInfo().examName);
      setValue("array.0.examId", getSelectedExamInfo().examId);
      setValue("array.0.batchId", getSelectedExamInfo().batchId);
      setValue(
        "array.0.examAvailableType",
        getSelectedExamInfo().examAvailableType
      );
      setValue("array.0.examCategory", getSelectedExamInfo().examCategory);
      setValue("array.0.examCost", getSelectedExamInfo().examCost);
      setValue("array.0.creationType", getSelectedExamInfo().examCreationType);
      setValue("array.0.complexity", getSelectedExamInfo().examType);
    }
    sessionStorage.setItem("routeFrom", "qb");
  }, []);

  useEffect(() => {
    return () => {
      setSelectedExamInfo({});
    };
  }, []);

  const linkFunction = (params) => {
    return (
      <div
        className="text-link"
        data-toggle="modal"
        data-target="#myModalwhereUsed"
        onClick={() => {
          const qId = params?.data?.questionId;
          setCurrentQuestion(qId);
          get(apiPaths.questionbyid, { id: qId })
            .then(({ result }) => {
              setQuestionPopupData({ ...params?.data, ...result });
              nav(params?.data?.questionId);
            })
            .catch((err) => console.log(err));
        }}
      >
        {params?.data?.questionId}
      </div>
    );
  };
  const nav = (id) => {
    setExamViewQuestionId(id);
    setShowViewQuestion(true);
    setShowWhereUsedGrid(true);
  };

  let plotSelectQuestionsGrid = (rowData) => {
    createExamColumnDefs.forEach((ele) => {
      if (ele?.headerName === "Question ID") {
        ele.cellRendererFramework = linkFunction;
      }
    });

    gridOptions.suppressRowClickSelection = true;
    gridOptions.rowSelection = "multiple";
    gridOptions.pagination = true;
    gridOptions.columnDefs = createExamColumnDefs;

    gridOptions.rowData = rowData;

    gridOptions.onFirstDataRendered = (params) => {
      gridApi.current = params.api;
      // params.api.sizeColumnsToFit();

      gridApi.current.forEachNode((node) => {
        node.setSelected(
          !!node.data && manualQuestions.includes(node.data.questionId)
        );
      });
    };

    gridOptions.isRowSelectable = (params) => {
      console.log('params: ', params);
      return (
        (!params?.data?.disabled &&
        getSelectedExamInfo()?.status !== "APPROVED" &&
        getSelectedExamInfo()?.status !== "PUSHED TO APP" &&
        getSelectedExamInfo()?.status !== "REJECTED") ||
        !examid
      );
    };

    // setTimeout(() => gridApi?.current?.setRowData(rowData));
    setGridOptions(gridOptions);
  };

  gridOptions.onSelectionChanged = (params) => {
    const selectedRows = params.api.getSelectedRows().map((e) => e?.questionId);
    console.log("selectedRows: ", selectedRows);
    console.log("selectedRows: ", selectionHistory);
    const rows = getUniqueAfterMerge(selectedRows, manualQuestions);
    let unselectedQuestion = selectionHistory.filter(
      (el) => !selectedRows.includes(el)
    );
    console.log("rows: ", rows);
    if (selectedRows.length === 0) {
      unselectedQuestion = selectionHistory;
    }
    if (selectionHistory.length === 0) {
      unselectedQuestion = [];
    }
    console.log("unselectedQuestion: ", unselectedQuestion);
    const newSelectionHistory = rows.filter(
      (el) => selectedRows.includes(el) || !unselectedQuestion.includes(el)
    );
    console.log("newSelectionHistory: ", newSelectionHistory);
    setManualQuestions(newSelectionHistory);
  };

  const onSelect = (id, selectMode) => {
    let rows = [];
    if (selectMode) {
      rows = getUniqueAfterMerge(manualQuestions, [id]);
    } else {
      rows = manualQuestions.filter((el) => el !== id);
    }
    setManualQuestions(rows);
    gridApi.current.forEachNode((node) => {
      node.setSelected(!!node.data && rows.includes(node.data.questionId));
    });
  };

  useEffect(() => {
    get(apiPaths.subjects, { tenantId: tenantId, batchId: +batchValue }).then(
      (res) => {
        setSubjects(res.result);
        const getSubject = (ids) => {
          const sbjcts = res.result.map((el) => {
            return {
              value: el.subjectId,
              label: el.subject,
            };
          });
          const filteredSubjts = sbjcts.filter((el) => (ids||[]).includes(el?.value));
          setSubjectValue(filteredSubjts);
        };
        if (examid) {
          getSubject(getSelectedExamInfo().subjectIdsUsedInExam);
        }
      }
    );
  }, [batchValue, id, tenantId]);

  useEffect(() => {
    get(apiPaths.batches, { tenantId: tenantId, branchId: branchValue }).then(
      (res) => {
        const resp = (res?.result || []).filter(
          (el) => el.branchId === +branchValue
        );
        setBatches(resp);
      }
    );
  }, [branchValue, id, tenantId]);

  useEffect(() => {
    if (examid) {
      get(apiPaths.batches, {
        tenantId: tenantId,
        branchId: getSelectedExamInfo().branchId,
      }).then((res) => {
        setBatches(res?.result);
      });
    }
  }, []);

  useEffect(() => {
    const body = {};
    if (createdDate) {
      body["createdDate"] = new Date(createdDate);
    }

    if (updatedDate) {
      body["updatedDate"] = new Date(updatedDate);
    }

    if (
      (getSelectedExamInfo().status !== "APPROVED" &&
        getSelectedExamInfo().status !== "PUSHED TO APP" &&
        getSelectedExamInfo().status !== "REJECTED") ||
      !examid
    ) {
      postData(`${apiPaths.getQuestionsForExam}`, {
        data: {
          batchId: getValues()?.batchId,
          tenantId: tenantId,
          subjectIds:
            filteredSubject.length > 0
              ? filteredSubject.map((el) => el.value)
              : subjectValue.map((el) => el.value),
          examCategory: getValues()?.examCategory?.toUpperCase(),
          courseIds: courseValue.map((el) => el.value),
          tagIds: tagValue.map((el) => el.value),
          includeQuestionsFromQB: includeQuestionsFromQB,
          topicIds: topicValue.map((el) => el.value),
          examId: examid || 0,
          approvedBy: approvedBy?.label,
          createdBy: createdBy?.label,
          numOfTimesUsedInExam: +numOfTimesUsedInExam,
          issueReported: issueReported.value,
          questionComplexity: complexity,
          ...body,
        },
        headers: {
          tenantId: getUserDetails().tenantId,
          userEmail: getUserDetails().email,
        },
      }).then((res) => {
        if (res && res.result) {
          // on load or the first time the syncing the table
          if (firstTimeApiCall) {
            const selectedQuestion = (res.result || []).reduce((acc, el) => {
              if (el.checked) {
                acc.push(el?.questionId);
              }
              return acc;
            }, []);

            setManualQuestions(selectedQuestion);
            if (gridApi.current) {
              gridApi.current.forEachNode((node) => {
                node.setSelected(
                  !!node.data && selectedQuestion.includes(node.data.questionId)
                );
              });
            }

            if (gridApi2.current) {
              gridApi2.current.forEachNode((node) => {
                node.setSelected(
                  !!node.data && selectedQuestion.includes(node.data.questionId)
                );
              });
            }

            setSelectionHistory(selectedQuestion);
            setFullQuestions(res?.result);
            setFirstTimeApiCall(false);
          } else {
            const currentQuestions = (res.result || []).map(
              (el) => el?.questionId
            );
            console.log("currentQuestions: ", currentQuestions);
            const currentSelectedQuestion = currentQuestions.filter((el) =>
              manualQuestions.includes(el)
            );
            console.log("currentSelectedQuestion: ", currentSelectedQuestion);
            setSelectionHistory(currentSelectedQuestion);
            if (gridApi.current) {
              gridApi.current.forEachNode((node) => {
                node.setSelected(
                  !!node.data && manualQuestions.includes(node.data.questionId)
                );
              });
            }
          }

          plotSelectQuestionsGrid(res?.result);
          setQuestionData(res?.result);

          // for pagination of qs viewer
          if (res?.result.length > 0) {
            if (tabValue === 1) {
              const qs = (res?.result || []).filter((el) =>
                manualQuestions.includes(el.questionId)
              );
              setQBCount(qs[qs.length - 1]?.questionId);
            } else {
              setQBCount(res?.result[res?.result.length - 1]?.questionId);
            }
          }

          if (tabValue === 1) {
            const qs = (res?.result || []).filter((el) =>
              manualQuestions.includes(el.questionId)
            );
            setPrevQuestion(
              qs[qs.findIndex((el) => el?.questionId === currentQuestn) - 1]
                ?.questionId ?? 0
            );
          } else {
            setPrevQuestion(
              res?.result[
                res?.result.findIndex(
                  (el) => el?.questionId === currentQuestn
                ) - 1
              ]?.questionId ??
                res?.result[0]?.questionId ??
                0
            );
          }

          if (tabValue === 1) {
            const qs = (res?.result || []).filter((el) =>
              manualQuestions.includes(el.questionId)
            );
            setNxtQuestion(
              qs[qs.findIndex((el) => el?.questionId === currentQuestn) + 1]
                ?.questionId ?? currentQuestn
            );
          } else {
            setNxtQuestion(
              res?.result[
                res?.result.findIndex(
                  (el) => el?.questionId === currentQuestn
                ) + 1
              ]?.questionId ?? currentQuestn
            );
          }
        }
        if (currentQuestn) {
          nav(currentQuestn);
        }
      });
    }
    setSearch(false);
  }, [
    subjectValue,
    id,
    currentQuestn,
    search,
    manualQuestions.length,
    tabValue,
    createdDate,
    updatedDate,
  ]);

  useEffect(() => {
    if (
      getSelectedExamInfo().status === "APPROVED" ||
      getSelectedExamInfo().status === "PUSHED TO APP" ||
      getSelectedExamInfo().status === "REJECTED" ||
      !examid
    ) {
      getData(`${apiPaths.getQuestionsByExamId + "/" + examid}`, {
        data: {},
        headers: {
          tenantId: getUserDetails().tenantId,
          userEmail: getUserDetails().email,
        },
      }).then((resExist) => {
        if (resExist && resExist.result) {
          const questions = (resExist.result || []).map((el) => el?.questionId);
          setManualQuestions(questions);

          setSelectionHistory(questions);
          setFullQuestions(resExist?.result);
          plotSelectQuestionsGrid(resExist?.result);
          setQuestionData(resExist?.result);
          console.log("resExist?.result: ", currentQuestn);
          console.log("resExist?.result: ", resExist?.result);
          console.log(
            "resExist?.result: ",
            resExist?.result.findIndex((el) => el?.questionId === currentQuestn)
          );
          setQBCount(
            resExist?.result[resExist?.result.length - 1]?.questionId ??
              currentQuestn
          );

          setPrevQuestion(
            resExist?.result[
              resExist?.result.findIndex(
                (el) => el?.questionId === currentQuestn
              ) - 1
            ]?.questionId ?? currentQuestn
          );

          setNxtQuestion(
            resExist?.result[
              resExist?.result.findIndex(
                (el) => el.questionId === currentQuestn
              ) + 1
            ]?.questionId ?? currentQuestn
          );
          if (currentQuestn) {
            nav(currentQuestn);
          }
        }
      });
    }
  }, [currentQuestn]);

  useEffect(() => {
    plotSelectQuestionsGrid(questionData);
  }, [subjectValue, questionData]);

  const onChangeBatch = (batchId) => {
    setBatchValue(batchId);
    setShowCourseInput(true);
  };

  const onChangeBranch = (branchId) => {
    setBranchValue(branchId);
  };

  const onLockSubmit = (formData) => {
    formData.status = "SENT FOR APPROVAL";
    onSubmit(formData);
  };
  const onSaveSubmit = (formData) => {
    if (
      watch("creationType")?.toUpperCase() !== "MANUAL" &&
      watch("creationType")?.toUpperCase() !== "AUTOMATIC"
    ) {
      Toaster(toast.TYPE.ERROR, "question mode input is empty");
    } else {
      formData.status = "SAVED";
      onSubmit(formData);
    }
  };

  const onSubmit = (formData) => {
    if (errors && Object.keys(errors)?.length > 0 && process && process.exit) {
      process.exit(1);
    } else {
      formPayloadForCreateExam(formData);
    }
  };
  let formPayloadForCreateExam = (formData) => {
    const formattedData = () => {
      let configData = {};
      let subjectQuestionCount = {};
      automaticConfig.forEach((item, index) => {
        const newItem = {
          approvedBy: item.approvedBy,
          totalQuestion: +item.totalQuestion,
          batchId: "",
          courseIds: item.courseIds.map((id) => 0),
          createdBy: item.createdBy,
          examCategory: "",
          examId: index,
          includeQuestionsFromQB: item.includeQuestionsFromQB.value,
          issueReported: item.issueReported.value,
          numOfTimesUsedInExam: item.numOfTimesUsedInExam,
          questionComplexity: item.questionComplexity.value,
          subjectIds: [item.subjectIds.value],
          tagIds: item.tagIds.map((id) => 0),
          topicIds: item.topicIds.map((id) => 0),
        };
        configData = {
          ...configData,
          [+item.subjectIds.value]: {...newItem, 
            batchId: batchValue, 
          },
        };
        subjectQuestionCount = {
          ...subjectQuestionCount,
          [+item.subjectIds.value]: newItem.totalQuestion,
        };
      });
      subjectValue.forEach(el => {
        if (!subjectQuestionCount[el.value]) {
          subjectQuestionCount[el.value] = 0;
        }
        if (!configData[el.value]) {
          configData[el.value] = {
            approvedBy: "",
            totalQuestion: 0,
            batchId: batchValue, 
            courseIds: [],
            createdBy: "",
            examCategory: "",
            examId: 0,
            includeQuestionsFromQB: true,
            issueReported: false,
            numOfTimesUsedInExam: 0,
            questionComplexity: "ALL",
            subjectIds: [el.value],
            tagIds: [],
            topicIds: [],
          };
        }
      })
      
      return { configData, subjectQuestionCount };
    };
    let data = {
      exam: {
        batch: batchValue,
        batchId: batchValue,
        branch: branchValue,
        branchId: branchValue,
        comments: "",
        createdBy: getUserDetails().email,
        examAvailableType: formData?.examAvailableType,
        examCategory: formData?.examCategory,
        examCost: formData?.examCost || "-",
        examCreationType: formData?.creationType?.toUpperCase(),
        examActiveState: "yes",
        examId: examid ? formData.examId : 0,
        examName: formData?.examName,
        examType: formData?.complexity?.toUpperCase(),
        status: formData?.status,
        subject: "string",
        subjectId: 0,
        subjectIdsUsedInExam: subjectValue.map((el) => el.value),
        totalQuestions: parseInt(formData?.totalQuestions, 10),
        updatedBy: getUserDetails().email,
      },
      
      questionIds: manualQuestions,
    };


    if (watch("creationType") === "Automatic") {
      data = {
        ...data,
        subjectQuestionCount: formattedData().subjectQuestionCount,
        subjectWiseFilter: formattedData().configData,
        totalQuestions: Object.values(formattedData().subjectQuestionCount).reduce((acc, el) => {
          acc += el
          return acc
        }, 0)
      }
      if (Object.values(formattedData().subjectQuestionCount).some(el => el ===0)) {
        Toaster(toast.TYPE.ERROR, 'Number of questions are not added for all the subject in automatic')
        return;
      }
    }
    postData(apiPaths.saveExam, {
      data,
      params: { tenantId: tenantId },
    })
      .then((res) => {
        if (res?.status === "OK") {
          Toaster(
            toast.TYPE.SUCCESS,
            toasterMessages.SUCCESS[formData?.status]
          );
          props.history.push("/app/exams/examsInfo");
        }
      })
      .catch((e) => Toaster(toast.TYPE.ERROR, e?.result ?? e));
  };

  return (
    <div
      class="addquestion-main"
      style={{ display: "flex", flexDirection: "column" }}
    >
      <div className="main-heading">
        {!examid ? "Create Exam" : "Edit Exam"}
      </div>
      <div className="background-common-div">
        <div class="btn-div">
          <div style={{ float: "right" }}>
            {!examid && (
              <input
                class="btn-common"
                type="button"
                value="Save"
                onClick={handleSubmit(onSaveSubmit)}
              />
            )}
            {examid && getSelectedExamInfo().status !== "APPROVED" && (
              <input
                class="btn-common"
                type="button"
                value="Save"
                onClick={handleSubmit(onSaveSubmit)}
              />
            )}
            {!examid && (
              <input
                class="btn-common"
                type="button"
                value="Send For Approval"
                onClick={handleSubmit(onLockSubmit)}
              />
            )}
          </div>
        </div>
        <div className="common-div">
          <form>
            {
              <div
                className="row"
                style={{
                  display: `${
                    !(showFilter && showFullscreen) ? "flex" : "none"
                  }`,
                }}
              >
                <ExamForm
                  examid={examid}
                  register={register}
                  errors={errors}
                  watch={watch}
                  onChangeBranch={onChangeBranch}
                  branches={branches}
                  branchValue={branchValue}
                  subjects={subjects}
                  batches={batches}
                  onChangeBatch={onChangeBatch}
                  setSubjectValue={setSubjectValue}
                  subjectValue={subjectValue}
                  setFirstTimeApiCall={setFirstTimeApiCall}
                />
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  {watch("creationType") === "Automatic" && (
                    <>
                      <div class="heading-small">Automatic Configuration:</div>
                      <div class="questions-dropdown">
                        <label class="questions-dropdown-label">
                          Total Questions *
                        </label>
                        <div class="questions-dropdown-input">
                          <input
                            class="form-details"
                            type="number"
                            disabled
                            value={Object.values(automaticConfig).reduce(
                              (acc, el) => {
                                acc += +el.totalQuestion;
                                return acc;
                              },
                              0
                            )}
                            placeholder="Total Questions"
                            name="totalQuestions"
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <Divider light style={{ marginBottom: "5px" }} />
                </div>
              </div>
            }

            {watch("creationType") === "Automatic" && !examid && (
              <>
                <AutomaticConfig
                  showAutomaticFilter={true}
                  onResetConfig={() => {
                    setAutomaticConfig([]);
                  }}
                  automaticConfig={automaticConfig}
                  subjectValue={subjectValue}
                  addConfig={(configProps) => {
                    const index = automaticConfig.findIndex(
                      (config) =>
                        config.subjectIds.value === configProps.subjectIds.value
                    );
                    if (index !== -1) {
                      // configProps already exists in automaticConfig, so update it
                      const automaticConfigCopy = [...automaticConfig];
                      automaticConfigCopy[index] = configProps;
                      setAutomaticConfig(automaticConfigCopy);
                    } else {
                      // configProps doesn't exist in automaticConfig, so push it
                      const automaticConfigList = [
                        ...automaticConfig,
                        configProps,
                      ];
                      setAutomaticConfig(automaticConfigList);
                    }
                  }}
                />
              </>
            )}

            {((watch("creationType") !== "Automatic" && !examid) ||
              examid > 0) && (
              <>
                <ManualConfiguration
                  subjectValue={subjectValue}
                  showFilter={showFilter}
                  manualQuestions={manualQuestions}
                  questionData={questionData}
                  filteredSubject={filteredSubject}
                  register={register}
                  getValues={getValues}
                  errors={errors}
                  fullQuestions={fullQuestions}
                  showFullscreen={showFullscreen}
                  setShowFullscreen={setShowFullscreen}
                  setShowFilter={setShowFilter}
                />

                <ExamContent
                  setNumOfTimesUsedInExam={setNumOfTimesUsedInExam}
                  fullQuestions={fullQuestions}
                  filteredSubject={filteredSubject}
                  setFilteredSubject={setFilteredSubject}
                  subjectValue={subjectValue}
                  courses={courses}
                  courseValue={courseValue}
                  setCourseValue={setCourseValue}
                  tags={tags}
                  tagValue={tagValue}
                  setTagValue={setTagValue}
                  topics={topics}
                  topicValue={topicValue}
                  setTopicValue={setTopicValue}
                  createdBy={createdBy}
                  setCreatedBy={setCreatedBy}
                  approvedBy={approvedBy}
                  setApprovedBy={setApprovedBy}
                  complexity={complexity}
                  setComplexity={setComplexity}
                  users={users}
                  showFilter={showFilter}
                  gridOptions={gridOptions}
                  manualQuestions={manualQuestions}
                  showGrid={showGrid}
                  gridApi2={gridApi2}
                  setManualQuestions={setManualQuestions}
                  getSelectedExamInfo={getSelectedExamInfo}
                  setTabValue={setTabValue}
                  setSearch={setSearch}
                  setIncludeQuestionsFromQB={setIncludeQuestionsFromQB}
                  setIssueReported={setIssueReported}
                  setCreatedDate={setCreatedDate}
                  setUpdatedDate={setUpdatedDate}
                />
              </>
            )}
          </form>
        </div>
      </div>

      <ExamModal
        showWhereUsedGrid={showWhereUsedGrid}
        setShowWhereUsedGrid={setShowWhereUsedGrid}
        setShowViewQuestion={setShowViewQuestion}
        showViewQuestion={showViewQuestion}
        prevQuestion={prevQuestion}
        nxtQuestion={nxtQuestion}
        QBCount={QBCount}
        questionPopupData={questionPopupData}
        currentQuestion={currentQuestion}
        onSelect={onSelect}
        manualQuestions={manualQuestions}
        setCurrentQuestion={setCurrentQuestion}
      />
    </div>
  );
}
